module.exports = __webpack_public_path__ + "img/hk_lv1_product_global@2x.3acb9575.png";